import {
  ADVISOR_SETTINGS_RECEIVED,
  ADVISOR_DETAILS_RECEIVED
} from './types'

export default function stats(state = {}, action = {}){
  switch (action.type) {
    case ADVISOR_SETTINGS_RECEIVED:
      return {
        ...state,
        ...action.settings
      }
    case ADVISOR_DETAILS_RECEIVED:
      return  {
        ...state,
        details: action.details
      }
    default:
      return state
  }
}